import request from '@/utils/request'

let Rescue_serviceApi = {

  /*驾驶员列表*/
  list(data) {
    return request._post('/shop/plus.pick_cotton.Index/index', data);
},
/*添加驾驶员*/
add(data) {
    return request._post('/shop/plus.pick_cotton.Index/add', data);
},
/*修改驾驶员*/
edit(data) {
    return request._post('/shop/plus.pick_cotton.Index/edit', data);
},
/*删除驾驶员*/
del(data) {
    return request._post('/shop/plus.pick_cotton.Index/del', data);
},
/*驾驶员详情*/
detail(data) {
  return request._post('/shop/plus.pick_cotton.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.pick_cotton.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.pick_cotton.Setting/getSetting', data, errorback);
    },
    // 审核
 passCanel(data) {
    return request._post('/shop/plus.pick_cotton.Index/passCanel', data);
  },
}
export default Rescue_serviceApi;



// WEBPACK FOOTER //
// ./src/api/pick_cotton.js